import React, { JSX } from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    ReferenceManyField,
    useRecordContext,
    Datagrid, SelectField
} from 'react-admin';
import {
    Grid,
} from '@mui/material';
import { currency, couponTypes, couponDuration } from "../../defaults/defaults";

const ShowAddressTitle: () => JSX.Element = (): JSX.Element => {
    const record: any = useRecordContext();
    if (!record) return null;
    return <span>{ "Invoice #" + record.id }</span>
}

export const CouponShow: () => JSX.Element = (): JSX.Element => {

    return(
        <Show actions={ false } title={ <ShowAddressTitle /> }>
            <Grid container spacing={ 2 }>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="name" />
                        <TextField source="code" />
                        <TextField source="amountOff" />
                        <SelectField source="currency" choices={ currency } />
                        <SelectField source="duration" choices={ couponDuration } />
                        <SelectField source="discountType" choices={ couponTypes } />
                        <TextField source="durationInMonths" label="Months To Apply Discount" />
                    </SimpleShowLayout>
                </Grid>
                <Grid size={ 6 }>
                    <SimpleShowLayout>
                        <DateField source="createdAt" showTime />
                        <ReferenceManyField
                            label="Applies to Products"
                            source="appliesToProducts"
                            target="id"
                            reference="subscription_products"
                            >
                            <Datagrid bulkActionButtons={ false }>
                                <TextField source="id" />
                                <TextField source="name" />
                            </Datagrid>
                        </ReferenceManyField>
                        <ReferenceManyField
                            label="Applied to Subscription"
                            source="subscriptions"
                            target="id"
                            reference="subscriptions"
                        >
                            <Datagrid bulkActionButtons={ false }>
                                <TextField source="id" />
                                <TextField source="status" />
                            </Datagrid>
                        </ReferenceManyField>
                    </SimpleShowLayout>
                </Grid>
            </Grid>
        </Show>
    );
}